import { HeaderCellProps } from '../types';

export const TenantStatusHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return <div>Status</div>;
};
